var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompensation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 133,
    viewBox: "0 0 197 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9637_84681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.067 1.98304C106.502 8.5532 97.0359 18.904 91.4344 26.7131L85.5699 21.7335C84.2791 20.6385 82.2871 21.3578 81.9843 23.0283L77.0681 50.348C76.7653 52.0186 78.3828 53.3933 79.9764 52.8179L106.016 43.4262C107.609 42.8507 107.984 40.7646 106.693 39.6615L101.123 34.9377C107.036 28.6793 117.864 19.5994 133.537 16.5941C157.338 12.0301 182.724 23.3001 198.524 45.2806C201.122 35.3694 203.719 25.4662 206.325 15.555C180.389 -4.46723 147.688 -10.0303 121.067 1.98304Z",
    fill: "url(#paint0_linear_9637_84681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.358 59.3583C286.924 85.1274 224.797 80.4436 224.391 98.4196C224.136 109.482 216.606 114.453 200.598 122.726C174.511 136.194 141.332 134.268 126.624 120.2C108.074 102.464 51.1109 143.763 49.6129 115.772C48.3062 91.2819 131.364 88.4764 147.053 81.2109C164.256 73.242 166.392 43.3805 182.423 40.2553C194.973 37.8175 195.953 49.9986 214.008 50.67C231.514 51.3255 274.677 15.9489 282.366 59.3503L282.358 59.3583Z",
    fill: "white",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.202 98.1205C195.847 98.1205 210.962 82.9582 210.962 64.2546C210.962 45.551 195.847 30.3887 177.202 30.3887C158.556 30.3887 143.441 45.551 143.441 64.2546C143.441 82.9582 158.556 98.1205 177.202 98.1205Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.201 95.0431C194.152 95.0431 207.893 81.2585 207.893 64.2545C207.893 47.2504 194.152 33.4658 177.201 33.4658C160.249 33.4658 146.508 47.2504 146.508 64.2545C146.508 81.2585 160.249 95.0431 177.201 95.0431Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.202 92.9015C192.974 92.9015 205.759 80.076 205.759 64.2549C205.759 48.4339 192.974 35.6084 177.202 35.6084C161.43 35.6084 148.645 48.4339 148.645 64.2549C148.645 80.076 161.43 92.9015 177.202 92.9015Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.592 74.4933L189.728 65.2295H165.457L177.592 74.4933Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.656 73.4463V91.5182",
    stroke: "#268B59",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.656 38.3975V58.9312",
    stroke: "#268B59",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.933 99.2311C144.933 99.2311 157.904 95.6704 157.904 91.2781C157.904 86.8858 144.933 83.3252 128.933 83.3252C112.932 83.3252 99.9609 86.8858 99.9609 91.2781C99.9609 95.6704 112.932 99.2311 128.933 99.2311Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.934 95.9537C143.214 95.9537 154.79 93.488 154.79 90.4466C154.79 87.4051 143.214 84.9395 128.934 84.9395C114.654 84.9395 103.078 87.4051 103.078 90.4466C103.078 93.488 114.654 95.9537 128.934 95.9537Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.863 90.791C157.887 90.9189 157.895 91.0468 157.895 91.1747V90.791H157.863Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9609 90.791V91.1747C99.9609 91.0468 99.9769 90.9189 99.9928 90.791H99.9609Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.933 99.1199C112.933 99.1199 99.9609 95.5631 99.9609 91.167V99.9672C99.9609 104.355 112.933 107.92 128.933 107.92C144.932 107.92 157.904 104.363 157.904 99.9672V91.167C157.904 95.5551 144.932 99.1199 128.933 99.1199Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.832 91.9092C157.856 92.0371 157.864 92.165 157.864 92.2928V91.9092H157.832Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9297 91.9092V92.2928C99.9297 92.165 99.9456 92.0371 99.9616 91.9092H99.9297Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.891 99.3984V105.801C116.656 105.905 117.436 106.001 118.233 106.088V99.6862C117.436 99.5983 116.656 99.5023 115.891 99.3984Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.137 99.6221V106.024C140.934 105.928 141.714 105.833 142.479 105.721V99.3184C141.714 99.4303 140.941 99.5342 140.137 99.6221Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.438 100.23V106.632C131.226 106.624 132.007 106.6 132.78 106.568V100.166C132.007 100.198 131.226 100.214 130.438 100.23Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.285 100.046V106.448C136.074 106.4 136.863 106.344 137.628 106.28V99.8779C136.863 99.9419 136.082 99.9978 135.285 100.046Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.742 99.9258V106.328C121.507 106.392 122.288 106.448 123.085 106.488V100.086C122.288 100.038 121.515 99.9897 120.742 99.9258Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.43 95.5215V101.924C102.884 102.204 103.394 102.475 103.96 102.739V96.3368C103.394 96.073 102.884 95.8012 102.43 95.5215Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9297 92.293V98.6953C99.9297 99.4626 100.328 100.198 101.061 100.893V94.491C100.328 93.7956 99.9297 93.0523 99.9297 92.293Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.047 98.5518V104.954C111.796 105.114 112.577 105.266 113.389 105.41V99.0073C112.577 98.8635 111.796 98.7116 111.047 98.5518Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.199 97.2324V103.635C106.924 103.891 107.705 104.13 108.542 104.354V97.9518C107.705 97.728 106.932 97.4882 106.199 97.2324Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.586 100.189V106.592C126.359 106.616 127.14 106.632 127.929 106.64V100.237C127.14 100.237 126.359 100.213 125.586 100.189Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.98 98.9034V105.306C145.658 105.186 146.303 105.05 146.933 104.914V98.5117C146.303 98.6476 145.65 98.7835 144.98 98.9034Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.441 97.8955V104.298C150.278 104.066 151.059 103.818 151.784 103.562V97.1602C151.059 97.4159 150.278 97.6637 149.441 97.8955Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.023 96.2494V102.652C154.589 102.38 155.099 102.1 155.553 101.812V95.4102C155.107 95.6979 154.589 95.9777 154.023 96.2494Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.926 94.3074V100.71C157.539 100.062 157.866 99.3908 157.866 98.6875V92.2852C157.866 92.9805 157.539 93.6599 156.926 94.3074Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.835 89.3844C146.835 89.3844 159.807 85.8237 159.807 81.4314C159.807 77.0392 146.835 73.4785 130.835 73.4785C114.834 73.4785 101.863 77.0392 101.863 81.4314C101.863 85.8237 114.834 89.3844 130.835 89.3844Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.837 86.107C145.117 86.107 156.693 83.6414 156.693 80.5999C156.693 77.5584 145.117 75.0928 130.837 75.0928C116.557 75.0928 104.98 77.5584 104.98 80.5999C104.98 83.6414 116.557 86.107 130.837 86.107Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.766 80.9355C159.79 81.0634 159.798 81.1913 159.798 81.3192V80.9355H159.766Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.863 80.9355V81.3192C101.863 81.1913 101.879 81.0634 101.895 80.9355H101.863Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.835 89.2723C114.835 89.2723 101.863 85.7154 101.863 81.3193V90.1195C101.863 94.5076 114.835 98.0724 130.835 98.0724C146.835 98.0724 159.807 94.5156 159.807 90.1195V81.3193C159.807 85.7074 146.835 89.2723 130.835 89.2723Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.734 82.0625C159.758 82.1904 159.766 82.3183 159.766 82.4462V82.0625H159.734Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.832 82.0625V82.4462C101.832 82.3183 101.848 82.1904 101.864 82.0625H101.832Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.793 89.5439V95.9462C118.558 96.0502 119.339 96.1461 120.136 96.234V89.8317C119.339 89.7438 118.558 89.6479 117.793 89.5439Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.039 89.7754V96.1777C142.836 96.0818 143.617 95.9859 144.382 95.874V89.4717C143.617 89.5836 142.844 89.6875 142.039 89.7754Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34 90.3833V96.7856C133.129 96.7776 133.91 96.7536 134.682 96.7216V90.3193C133.91 90.3513 133.129 90.3673 132.34 90.3833Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.188 90.1991V96.6014C137.976 96.5535 138.765 96.4975 139.53 96.4336V90.0312C138.765 90.0952 137.984 90.1511 137.188 90.1991Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.645 90.0713V96.4736C123.409 96.5375 124.19 96.5935 124.987 96.6334V90.2311C124.19 90.1832 123.417 90.1352 122.645 90.0713Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.332 85.6748V92.0771C104.786 92.3569 105.296 92.6286 105.862 92.8924V86.4901C105.296 86.2263 104.786 85.9546 104.332 85.6748Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.832 82.4385V88.8408C101.832 89.6081 102.23 90.3435 102.963 91.0388V84.6365C102.23 83.9411 101.832 83.1978 101.832 82.4385Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.949 88.7051V95.1074C113.698 95.2673 114.479 95.4191 115.292 95.563V89.1607C114.479 89.0168 113.698 88.8649 112.949 88.7051Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.102 87.3779V93.7802C108.827 94.036 109.608 94.2758 110.444 94.4996V88.0973C109.608 87.8735 108.835 87.6337 108.102 87.3779Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.488 90.3428V96.7451C128.261 96.7691 129.042 96.7851 129.831 96.793V90.3907C129.042 90.3907 128.261 90.3668 127.488 90.3428Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.883 89.0567V95.459C147.56 95.3391 148.205 95.2032 148.835 95.0674V88.665C148.205 88.8009 147.552 88.9368 146.883 89.0567Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.344 88.0488V94.4511C152.18 94.2193 152.961 93.9716 153.686 93.7158V87.3135C152.961 87.5692 152.18 87.817 151.344 88.0488Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.926 86.3949V92.7972C156.492 92.5255 157.001 92.2457 157.456 91.958V85.5557C157.009 85.8434 156.492 86.1232 155.926 86.3949Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.828 84.4607V90.863C159.442 90.2156 159.768 89.5442 159.768 88.8408V82.4385C159.768 83.1339 159.442 83.8133 158.828 84.4607Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.194 79.6012C145.195 79.6012 158.166 76.0405 158.166 71.6482C158.166 67.256 145.195 63.6953 129.194 63.6953C113.194 63.6953 100.223 67.256 100.223 71.6482C100.223 76.0405 113.194 79.6012 129.194 79.6012Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.196 76.3238C143.476 76.3238 155.052 73.8582 155.052 70.8167C155.052 67.7752 143.476 65.3096 129.196 65.3096C114.916 65.3096 103.34 67.7752 103.34 70.8167C103.34 73.8582 114.916 76.3238 129.196 76.3238Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.133 71.1523C158.157 71.2802 158.165 71.4081 158.165 71.536V71.1523H158.133Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.23 71.1523V71.536C100.23 71.4081 100.246 71.2802 100.262 71.1523H100.23Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.194 79.4813C113.195 79.4813 100.223 75.9244 100.223 71.5283V80.3285C100.223 84.7166 113.195 88.2814 129.194 88.2814C145.194 88.2814 158.166 84.7246 158.166 80.3285V71.5283C158.166 75.9164 145.194 79.4813 129.194 79.4813Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.102 72.2793C158.125 72.4072 158.133 72.5351 158.133 72.663V72.2793H158.102Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.199 72.2793V72.663C100.199 72.5351 100.215 72.4072 100.231 72.2793H100.199Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16 79.7607V86.163C116.925 86.267 117.706 86.3629 118.503 86.4508V80.0485C117.706 79.9606 116.925 79.8646 116.16 79.7607Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.398 79.9844V86.3867C141.195 86.2908 141.976 86.1949 142.741 86.083V79.6807C141.976 79.7926 141.203 79.8965 140.398 79.9844Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.699 80.6001V87.0024C131.488 86.9944 132.269 86.9704 133.042 86.9384V80.5361C132.269 80.5681 131.488 80.5841 130.699 80.6001Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.555 80.4159V86.8182C136.344 86.7702 137.132 86.7143 137.897 86.6504V80.248C137.132 80.312 136.351 80.3679 135.555 80.4159Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.012 80.2881V86.6904C121.777 86.7543 122.558 86.8103 123.354 86.8503V80.4479C122.558 80.4 121.785 80.352 121.012 80.2881Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.699 75.8916V82.2939C103.153 82.5737 103.663 82.8454 104.229 83.1092V76.7069C103.663 76.4431 103.153 76.1714 102.699 75.8916Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.199 72.6553V79.0576C100.199 79.8249 100.598 80.5602 101.331 81.2556V74.8533C100.598 74.1579 100.199 73.4146 100.199 72.6553Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.316 78.9131V85.3154C112.065 85.4753 112.846 85.6271 113.659 85.771V79.3687C112.846 79.2248 112.065 79.0729 111.316 78.9131Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.461 77.5947V83.997C107.186 84.2528 107.967 84.4926 108.804 84.7164V78.3141C107.967 78.0903 107.194 77.8505 106.461 77.5947Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.855 80.5518V86.9541C126.628 86.978 127.409 86.994 128.198 87.002V80.5997C127.409 80.5997 126.628 80.5757 125.855 80.5518Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25 79.2735V85.6758C145.927 85.5559 146.573 85.42 147.202 85.2841V78.8818C146.573 79.0177 145.919 79.1536 145.25 79.2735Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.711 78.2578V84.6601C150.548 84.4283 151.328 84.1805 152.054 83.9248V77.5225C151.328 77.7782 150.548 78.026 149.711 78.2578Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.285 76.6117V83.014C154.851 82.7423 155.361 82.4625 155.815 82.1748V75.7725C155.369 76.0602 154.851 76.34 154.285 76.6117Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.188 74.6775V81.0798C157.801 80.4324 158.128 79.761 158.128 79.0576V72.6553C158.128 73.3507 157.801 74.0301 157.188 74.6775Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.636 70.3131C142.636 70.3131 155.607 66.7524 155.607 62.3602C155.607 57.9679 142.636 54.4072 126.636 54.4072C110.635 54.4072 97.6641 57.9679 97.6641 62.3602C97.6641 66.7524 110.635 70.3131 126.636 70.3131Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.637 67.0357C140.917 67.0357 152.494 64.5701 152.494 61.5286C152.494 58.4871 140.917 56.0215 126.637 56.0215C112.357 56.0215 100.781 58.4871 100.781 61.5286C100.781 64.5701 112.357 67.0357 126.637 67.0357Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.566 61.873C155.59 62.0009 155.598 62.1288 155.598 62.2567V61.873H155.566Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6641 61.873V62.2567C97.6641 62.1288 97.68 62.0009 97.6959 61.873H97.6641Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.636 70.202C110.636 70.202 97.6641 66.6451 97.6641 62.249V71.0492C97.6641 75.4373 110.636 79.0021 126.636 79.0021C142.635 79.0021 155.607 75.4453 155.607 71.0492V62.249C155.607 66.6371 142.635 70.202 126.636 70.202Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.535 62.9912C155.559 63.1191 155.567 63.247 155.567 63.3749V62.9912H155.535Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6328 62.9912V63.3749C97.6328 63.247 97.6487 63.1191 97.6647 62.9912H97.6328Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 70.4805V76.8828C114.366 76.9867 115.147 77.0826 115.944 77.1705V70.7682C115.147 70.6803 114.366 70.5844 113.602 70.4805Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84 70.7041V77.1064C138.637 77.0105 139.417 76.9146 140.182 76.8027V70.4004C139.417 70.5123 138.645 70.6162 137.84 70.7041Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.141 71.312V77.7143C128.929 77.7063 129.71 77.6823 130.483 77.6504V71.248C129.71 71.28 128.929 71.296 128.141 71.312Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.988 71.1278V77.5301C133.777 77.4822 134.566 77.4262 135.331 77.3623V70.96C134.566 71.0239 133.785 71.0799 132.988 71.1278Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.445 71V77.4023C119.21 77.4662 119.991 77.5222 120.788 77.5622V71.1599C119.991 71.1119 119.218 71.0639 118.445 71Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.133 66.6035V73.0058C100.587 73.2856 101.097 73.5573 101.663 73.8211V67.4188C101.097 67.155 100.587 66.8833 100.133 66.6035Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6328 63.375V69.7773C97.6328 70.5446 98.0312 71.28 98.7643 71.9754V65.573C98.0312 64.8777 97.6328 64.1343 97.6328 63.375Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75 69.6338V76.0361C109.499 76.196 110.28 76.3478 111.093 76.4917V70.0894C110.28 69.9455 109.499 69.7936 108.75 69.6338Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.902 68.3145V74.7168C104.627 74.9725 105.408 75.2123 106.245 75.4361V69.0338C105.408 68.81 104.635 68.5702 103.902 68.3145Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.297 71.2715V77.6738C124.07 77.6978 124.851 77.7138 125.639 77.7218V71.3194C124.851 71.3194 124.07 71.2955 123.297 71.2715Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.684 69.9854V76.3877C143.361 76.2678 144.006 76.1319 144.636 75.9961V69.5938C144.006 69.7296 143.353 69.8655 142.684 69.9854Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.145 68.9775V75.3798C147.981 75.148 148.762 74.9003 149.487 74.6445V68.2422C148.762 68.498 147.981 68.7457 147.145 68.9775Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.727 67.3314V73.7337C152.292 73.462 152.802 73.1822 153.256 72.8945V66.4922C152.81 66.7799 152.292 67.0597 151.727 67.3314Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.629 65.3894V71.7917C155.242 71.1443 155.569 70.4729 155.569 69.7695V63.3672C155.569 64.0626 155.242 64.742 154.629 65.3894Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.581 59.9469C142.582 59.9469 155.553 56.3862 155.553 51.9939C155.553 47.6017 142.582 44.041 126.581 44.041C110.58 44.041 97.6094 47.6017 97.6094 51.9939C97.6094 56.3862 110.58 59.9469 126.581 59.9469Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.637 56.6695C140.917 56.6695 152.494 54.2039 152.494 51.1624C152.494 48.1209 140.917 45.6553 126.637 45.6553C112.357 45.6553 100.781 48.1209 100.781 51.1624C100.781 54.2039 112.357 56.6695 126.637 56.6695Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.512 51.498C155.536 51.6259 155.544 51.7538 155.544 51.8817V51.498H155.512Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6094 51.498V51.8817C97.6094 51.7538 97.6253 51.6259 97.6412 51.498H97.6094Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.581 59.8348C110.581 59.8348 97.6094 56.2779 97.6094 51.8818V60.682C97.6094 65.0701 110.581 68.6349 126.581 68.6349C142.581 68.6349 155.553 65.0781 155.553 60.682V51.8818C155.553 56.2699 142.581 59.8348 126.581 59.8348Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.535 52.585C155.559 52.7128 155.567 52.8407 155.567 52.9686V52.585H155.535Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6328 52.585V52.9686C97.6328 52.8407 97.6487 52.7128 97.6647 52.585H97.6328Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 60.0742V66.4765C114.366 66.5804 115.147 66.6764 115.944 66.7643V60.362C115.147 60.274 114.366 60.1781 113.602 60.0742Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84 60.2979V66.7002C138.637 66.6043 139.417 66.5084 140.182 66.3965V59.9941C139.417 60.106 138.645 60.21 137.84 60.2979Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.141 60.9057V67.3081C128.929 67.3001 129.71 67.2761 130.483 67.2441V60.8418C129.71 60.8738 128.929 60.8898 128.141 60.9057Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.988 60.7216V67.1239C133.777 67.0759 134.566 67.02 135.331 66.956V60.5537C134.566 60.6177 133.785 60.6736 132.988 60.7216Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.445 60.6016V67.0039C119.21 67.0678 119.991 67.1238 120.788 67.1637V60.7614C119.991 60.7135 119.218 60.6655 118.445 60.6016Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.133 56.1973V62.5996C100.587 62.8793 101.097 63.1511 101.663 63.4148V57.0125C101.097 56.7488 100.587 56.477 100.133 56.1973Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6328 52.9688V59.3711C97.6328 60.1384 98.0312 60.8737 98.7643 61.5691V55.1668C98.0312 54.4714 97.6328 53.7281 97.6328 52.9688Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75 59.2275V65.6298C109.499 65.7897 110.28 65.9416 111.093 66.0854V59.6831C110.28 59.5393 109.499 59.3874 108.75 59.2275Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.902 57.9082V64.3105C104.627 64.5663 105.408 64.8061 106.245 65.0299V58.6276C105.408 58.4038 104.635 58.164 103.902 57.9082Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.297 60.8652V67.2675C124.07 67.2915 124.851 67.3075 125.639 67.3155V60.9132C124.851 60.9132 124.07 60.8892 123.297 60.8652Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.684 59.5792V65.9815C143.361 65.8616 144.006 65.7257 144.636 65.5898V59.1875C144.006 59.3234 143.353 59.4593 142.684 59.5792Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.145 58.5713V64.9736C147.981 64.7418 148.762 64.494 149.487 64.2382V57.8359C148.762 58.0917 147.981 58.3395 147.145 58.5713Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.727 56.9252V63.3275C152.292 63.0557 152.802 62.776 153.256 62.4882V56.0859C152.81 56.3737 152.292 56.6534 151.727 56.9252Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.629 54.9831V61.3854C155.242 60.738 155.569 60.0666 155.569 59.3632V52.9609C155.569 53.6563 155.242 54.3357 154.629 54.9831Z",
    fill: "#40D9B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.629 50.2194L127.211 46.6865V55.4228L134.629 50.2194Z",
    fill: "#268B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.736 82.1908V77.507C174.051 77.459 171.278 76.6198 169.66 75.4608L170.768 72.3516C172.433 73.4626 174.839 74.3498 177.429 74.3498C180.712 74.3498 182.935 72.4475 182.935 69.8018C182.935 67.1562 181.134 65.6695 177.708 64.2787C172.991 62.4164 170.074 60.2823 170.074 56.2539C170.074 52.2255 172.8 49.4839 177.054 48.7885V44.0967H179.923V48.5967C182.696 48.6846 184.592 49.4279 185.931 50.2192L184.775 53.2805C183.803 52.729 181.907 51.6979 178.951 51.6979C175.389 51.6979 174.051 53.832 174.051 55.6944C174.051 58.1082 175.764 59.3152 179.787 60.9857C184.552 62.9279 186.951 65.3418 186.951 69.4741C186.951 73.1349 184.409 76.5718 179.644 77.3631V82.1908H176.728H176.736Z",
    fill: "#40D9B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9637_84681",
    x1: 88.8182,
    y1: 48.7696,
    x2: 200.13,
    y2: 30.3199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9637_84681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 135,
    fill: "white",
    transform: "translate(0 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensation);
export default __webpack_public_path__ + "static/media/compensation.e12820187b4bb929406462b424d58fe5.svg";
export { ForwardRef as ReactComponent };